import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from '@finder/shared/constants/app.constants';
import { filterDisneyInternalHeaders } from '@finder/shared/utils/headers/disney-internal-headers';

@Injectable()
export class CustomDisneyHeadersInterceptor implements HttpInterceptor {
    private requestHeaders = inject(HEADERS, { optional: true });

    /**
     * Forward x-disney-internal-* headers on API requests during SSR (HEADERS token from Express).
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const disneyInternalHeaders = filterDisneyInternalHeaders(this.requestHeaders);

        if (Object.keys(disneyInternalHeaders).length === 0) {
            return next.handle(req);
        }

        return next.handle(req.clone({
            setHeaders: disneyInternalHeaders,
        }));
    }
}
